<style lang="less" scoped>
.dhxwList{position: relative;width: 100%;flex-direction: column;justify-content: center;align-items: center;margin: 0;padding: 0;background: #fff;}
.mains{position: relative;width: 800px;display: flex;}
.first{display: flex;flex-direction: column;width: 780px;margin-right: 20px;margin-left: 353px;}
ul{list-style: none;margin: 0px;margin-left:-40px;margin-top: 0px;margin-bottom: 30px;;}
.imgTitleContent{text-align: left;}
.el-button{width: 800px;font-size: 16px;background-image: linear-gradient(#ECFAFF, #ECF6FF);margin-bottom: 30px;}
</style>

<template>
  <div class="dhxwList">
    <Navigation v-if="this.catid !== ''" :navigationdatas="navigationList2"></Navigation>
    <Navigation v-else :navigationdatas="navigationList"></Navigation>
    <div class="mains">
      <div class="first">
        <ul>
          <li v-for="(item,index) in imgTitleContentdata" :key="index">
            <ImgTitleContent class="imgTitleContent" :imgTitleContentItem="item" @handleClick="goDetails"></ImgTitleContent>
          </li>
        </ul>
        <el-button @click="getOthers">加载更多</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ImgTitleContent from '../assembly/ImgTitleContent'
import Navigation from '../assembly/Navigation'
export default {
  components: {
    ImgTitleContent,
    Navigation
  },

  name: '',
  data()
  {
    return {
      // ImgTitleContent组件数据
      imgTitleContentdata: [],
      currentPage: 1,
      navigationList: [
        {
          theme: '首页',
          path: '/Kyforum'
        },
        {
          theme: '矿业论坛',
          path: '/Promoin'
        },
        {
          theme: '大会新闻',
          path: '/NewsList'
        },
        {
          theme: '会议资讯',
          path: ''
        }
      ],
      navigationList2: [
        {
          theme: '首页',
          path: '/Kyforum'
        },
        {
          theme: '矿业论坛',
          path: '/Promoin'
        },
        {
          theme: '会议资讯',
          path: ''
        }
      ],
      catid: ''
    }
  },
  created()
  {
  },
  watch: {
    $route: {
      handler(nval)
      {
        this.navigationList = []
        if (nval.query.id)
        {
          this.navigationList = [
            {
              theme: '首页',
              path: '/Kyforum'
            },
            {
              theme: '矿业论坛',
              path: '/Promoin'
            },
            {
              theme: '大会新闻',
              path: '/NewsList'
            },
            {
              theme: '会议资讯',
              path: ''
            }
          ]
          this.catid = nval.query.id
          this.currentPage = 1
          this.getNewsList(nval.query.id)
        }
        else
        {
          this.navigationList = [
            {
              theme: '首页',
              path: '/Kyforum'
            },
            {
              theme: '矿业论坛',
              path: '/Promoin'
            },
            {
              theme: '会议资讯',
              path: ''
            }
          ]
          this.catid = ''
          this.currentPage = 1
          this.getNewsList2()
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  methods: {
    getNewsList(catid)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 118, _exp: `catid = ${catid}`, orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 10 * this.currentPage}
      window.post.getPost(paras).then((ret) =>
      {
        this.imgTitleContentdata = []
        ret[0].data.forEach(item =>
        {
          this.imgTitleContentdata.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, introduce: item.introduce, release: '发布', time: item.addtime, description: '来源', value: item.copyfrom})
        })
      })
    },
    getNewsList2()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 118, _exp: `id > 0 and examine = 0`, orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 10 * this.currentPage}
      window.post.getPost(paras).then((ret) =>
      {
        this.imgTitleContentdata = []
        ret[0].data.forEach(item =>
        {
          this.imgTitleContentdata.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, introduce: item.introduce, release: '发布', time: item.addtime, description: '来源', value: item.copyfrom})
        })
      })
    },
    // 根据点击的页码，重新渲染然页面展示的数据
    // 点击加载更多，依次添加10条数据，并重新渲染然页面展示的数据
    getOthers()
    {
      this.currentPage++
      if (this.catid)
        this.getNewsList(this.catid)
      else
        this.getNewsList2()
    },
    // 跳大會新聞详情页面，并将被点击的对象的id提交到vuex
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/KyzhzxDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/NewsKyzhzx.vue